export default __webpack_public_path__ + "static/media/liveCourse.090ce401.svg";